import { AuPolicy } from '../oauth';
import { fakeOrgDto } from './org.data';
import { UserDto } from './user';

export const fakeUserDto = (): UserDto => {
  return {
    id: 5,
    name: 'John Doe',
    email: 'john@example.com',
    policies: [AuPolicy.Test],
    superUser: false,
    org: fakeOrgDto(),
    organizations: [fakeOrgDto()],
  };
};
